module.exports = __webpack_public_path__ + "img/visa_logo.b1684820.svg";